import type { PassengerTripPricing } from "@b2bportal/air-booking-api";
import type { PassengerPricing } from "@b2bportal/air-shopping-api";
import type { Dictionary } from "lodash";

export const getPaxPricingDetails = (
  originalPaxPricingMap: Dictionary<PassengerTripPricing>,
  shoppedPaxPricingMap: Dictionary<PassengerPricing>,
  type: string
) => {
  const originalPaxPricing = originalPaxPricingMap[type];
  const shoppedPaxPricing = shoppedPaxPricingMap[type]?.pricing;
  let baseAmount = 0;
  let currency = "";
  let taxes = 0;

  if (shoppedPaxPricing != null) {
    baseAmount += shoppedPaxPricing.baseAmount.fiat.value;
    currency = shoppedPaxPricing.baseAmount.fiat.currencyCode;
    taxes += shoppedPaxPricing.taxAmount.fiat.value;
  } else {
    console.error(
      `Pax type (${type}) not found in shopped booking's pricing map`,
      shoppedPaxPricing
    );
  }

  if (originalPaxPricing != null) {
    baseAmount += originalPaxPricing.baseWithoutMargin.fiat.value;
    currency = originalPaxPricing.currency;
    taxes += originalPaxPricing.taxes.fiat.value;
  } else {
    console.error(
      `Pax type (${type}) not found in original booking's pricing map`,
      originalPaxPricing
    );
  }

  return { baseAmount, currency, taxes };
};
